import AboutNavtext3 from './about-nav-text3';
export default AboutNavtext3